import { render, staticRenderFns } from "./Demo-screen.vue?vue&type=template&id=1cd68c9c&scoped=true&"
import script from "./Demo-screen.vue?vue&type=script&lang=js&"
export * from "./Demo-screen.vue?vue&type=script&lang=js&"
import style0 from "./Demo-screen.vue?vue&type=style&index=0&id=1cd68c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd68c9c",
  null
  
)

export default component.exports